import {
    Directive,
    HostBinding,
    Input,
    OnDestroy,
    OnInit,
    inject
} from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { RuleValidationMessage } from "~app/common/services/cqs/models/rule-validation-message";
import { VirkeskopValidationService } from "../../services/validation/virkeskop-validation.service";

@Directive({ selector: "[raskVirkeskopRule]" })
export class VirkeskopValidationRuleDirective implements OnInit, OnDestroy {
    @Input() entityGuid?: string;
    @HostBinding("class.vk-error") highlightError = false;
    @Input() messageId: string[];

    private readonly destroy$ = new Subject<void>();
    private readonly validationService = inject(VirkeskopValidationService);

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    ngOnInit(): void {
        this.validationService.validation$.pipe(
            takeUntil(this.destroy$)
        ).subscribe((messages) => {
            this.highlightError = this.included(messages);
        });
    }

    private included(messages: RuleValidationMessage[]): boolean {
        return messages.some(m =>
            (!this.entityGuid || m.entityGuids.includes(this.entityGuid))
            && this.messageId.includes(m.messageId));
    }
}
